import React, { useEffect, useMemo } from "react";
import { CircularProgress, Grid } from "@mui/material";
import { Field } from "formik";
import { FullWidthField } from "@poseidon/ui/components/form/FullWidthField";
import { FormikAutocomplete } from "@poseidon/ui/components/form/FormikAutocomplete";
import config from "../../config.json";
import DatePicker from "@poseidon/ui/components/form/DatePicker";
import { useIndustries } from "../../hooks/useIndustries";
import { useErrorMessage } from "@poseidon/ui/app/toasts/useErrorMessage";
import * as Yup from "yup";
import { EditSailorFormPanel } from "./EditSailorFormPanel";

export const IndustriesField = () => {
  const { industries, loading, error } = useIndustries();
  const { setError } = useErrorMessage();
  useEffect(() => {
    if (error) {
      setError(error);
    }
  }, [setError, error]);

  if (loading) {
    return <CircularProgress sx={{ alignSelf: "center" }} />;
  }

  return (
    <Field
      component={FormikAutocomplete}
      fullWidth={true}
      label="Industry Sector"
      name="industrySector"
      options={industries}
      margin="none"
    />
  );
};

const sailorDefaults = {
  employmentStatus: "",
  jobTitle: "",
  dateStartedJob: null,
};

export const validationSchema = Yup.object().shape({
  employmentStatus: Yup.string()
    .transform((v, ov) => (ov === null ? "" : v))
    .max(255),
  jobTitle: Yup.string().max(255),
  dateStartedJob: Yup.date().required("Job Start Date is required"),
});

export function EmploymentFields({ sailor, readonly }) {
  const initialValues = useMemo(
    () => ({
      ...sailorDefaults,
      ...sailor,
    }),
    [sailor]
  );
  return (
    <EditSailorFormPanel
      title="Employment Details"
      disabled={readonly}
      initialValues={initialValues}
      validationSchema={validationSchema}
      sailor={sailor}
    >
      <Grid container spacing={2} sx={{ mt: 3 }}>
        <Grid item xs={12} sm={6}>
          <Field
            component={FormikAutocomplete}
            fullWidth={true}
            label="Employment Status"
            name="employmentStatus"
            options={config.employmentStatus}
            margin="none"
            textFieldProps={{
              fullWidth: true,
              variant: "outlined",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={FullWidthField}
            name="jobTitle"
            label="Job Title"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field
            component={DatePicker}
            name="dateStartedJob"
            label="Date Started"
            margin="none"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <IndustriesField />
        </Grid>
      </Grid>
    </EditSailorFormPanel>
  );
}
